export default __webpack_public_path__ + "static/media/caorc.4010566e.jpg";